import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import axios from '../utils/posAxios';
import { MdDone, MdClear } from 'react-icons/md';
import StorageService from '../services/StorageService';
import update from 'immutability-helper';

class CrmCategoryForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      category_id: '',
      name: '',
    };
  }

  componentDidMount() {
    if (this.props.data.isEdit) {
      let data = this.props.data;
      console.log(data);
      let category = data.categoryList.find(x => x.id == data.selectedId);
      this.setState({
        isEdit: data.isEdit,
        category_id: data.selectedId,
        name: category.name,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (this.state.isEdit) {
      this.editData(user, comp, url);
    } else {
      this.addData(user, comp, url);
    }
  };

  addData(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      created_by: user.email,
    };
    axios
      .post(url + ':3004/v1/customer/category/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New Category added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  editData(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      category_id: this.state.category_id,
      name: this.state.name,
      update_by: user.email,
    };

    axios
      .post(url + ':3004/v1/customer/category/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Category updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    const detail = (
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>Name</Label>
            <Input
              name="name"
              value={this.state.name}
              onChange={this.changeHandler}
              required
            />
          </FormGroup>
        </Col>
      </Row>
    );

    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Category</ModalHeader>
        <ModalBody>{detail}</ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default CrmCategoryForm;
